import "./NorthernVirginia.module.css";
import Header from "@/reusable_sections/Header";
import NorthernVirginia from "./sections/NorthernVirginia";
import Coverage from "./sections/Coverage";
import Emergency from "./sections/Emergency";
import Footer from "@/reusable_sections/Footer";
export default function NorthernVirginiaPage() {
  return <div>
      <Header />
      <NorthernVirginia />
      <Coverage />
      <Emergency />
      <Footer />
    </div>;
}